import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { IonicModule } from "@ionic/angular";
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PageListElement, PagesService } from 'src/app/services/pages.service';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { Universe } from 'src/app/interfaces/universe.interface';
import { UniverseService } from 'src/app/services/universe.service';
import { ChatService } from 'src/app/services/chat.service';
import { TranslatePipe } from '@ngx-translate/core';
import { AppVersionItem, AppVersionService } from 'src/app/services/app-version.service';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	standalone: true,
	imports: [IonicModule, CommonModule, MatIconModule, TranslatePipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SidebarComponent implements OnInit {

	private router = inject(Router);
	private pagesService = inject(PagesService);
	public authService = inject(AuthService);
	public sharedService = inject(SharedService);
	public universeService = inject(UniverseService);
	public chatService = inject(ChatService);
	private appVersionService = inject(AppVersionService);
	
	pages: PageListElement[] = [];
	universes: any = null;
	currentUniverse:Universe|null = null;

	public ACCESS_LEVEL:number = 0;
	public PLATFORM_ACCESS_LEVEL: number = 0;

	version?: AppVersionItem;

	constructor(
	) { }


	async ionViewWillEnter() {
		this.PLATFORM_ACCESS_LEVEL = await this.authService.getPlatformRole();
	}

	async ngOnInit() {
		this.authService.getRole$().subscribe(role => {
			this.ACCESS_LEVEL = role;
		});

		// this.ACCESS_LEVEL = await this.authService.getRole();
		this.PLATFORM_ACCESS_LEVEL = await this.authService.getPlatformRole();

		this.pagesService.setActive(this.router.url);

		this.pagesService.pages$.subscribe(pages => this.pages = pages);
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				this.pagesService.setActive(event.url);
			});
		
		this.universeService.currentUniverse$.subscribe(async (u) => {
			if (u!=null) {
				this.currentUniverse = u;
			} else {
				await this.universeService.selectUniverse();
			}
		});

		this.appVersionService.getVersion().subscribe(data => {
			this.version = data.current;
		});
	}

	navigateTo(link: string) {
		if (link == '/logout') {
			this.authService.logout(true);
		} else {
			this.router.navigate([link]);
		}
	}

	async changeUniverse(event:Event) {
		if (event) {
			const target = event.target as HTMLIonSelectElement;
			const id_universe = target.value;
			this.universeService.selectUniverse(id_universe);
		}
	}

}
